import React, { useEffect, useState } from 'react';
import css from '../AiModal.module.css';
import { Icons } from '@Assets/SvgIcons';
import AiMessageInput from '../AiMessageInput';
import { MessageHolder } from './GeneralTab';
import { getUserInfo } from '@Store/feature/directory';
import { useAppSelector } from '@Store/hooks';
import { CoreServices } from '@Helper/CoreServices';
import { MergefloColors } from '@Helper/MergefloColors';
import axios from 'axios';
import {
  AiCategoriesResponse,
  AiQueryResponse,
  CategoryRow,
  Row,
} from '@Helper/Interfaces';
import { useEffectAsync } from '@Helper/Infra';
import { Avatar } from '@mui/material';
import { TabProps } from '../AiModal';
import { toast } from 'react-toastify';

export type AskListType = {
  id: string;
  name: string;
  parentId: string | null;
  prompt?: string;
  child?: AskListType[];
};

type CategoryListType = {
  id: string;
  name: string;
  child?: AskListType[];
  parentId: string | null;
};

const KnowledgebaseTab = ({
  currentConversationId,
  initialMessageHolder,
  setMainConversationId,
  setMainMessageHolder,
  setAskMainType,
  askMain,
}: TabProps) => {
  const messageRef = React.useRef<HTMLDivElement>(null);
  const [currentMessageHolder, setCurrentMessageHolder] =
    useState<MessageHolder[]>(initialMessageHolder);
  const userInfo = useAppSelector(getUserInfo);
  const coreServices = new CoreServices();

  const generateAvatar = () => {
    let response = '';
    if (userInfo?.name?.length && userInfo?.name?.length > 0)
      response = userInfo?.name[0];
    if (userInfo?.surname?.length && userInfo?.surname?.length > 0)
      response = response + userInfo?.surname[0];
    return response.length === 0 ? 'NO' : response.toUpperCase();
  };
  const mergefloColors = new MergefloColors();
  const [selectedAskItem, setSelectedAskItem] = useState<AskListType | null>(
    null
  );
  const [reselectedAskItem, setReSelectedAskItem] =
    useState<AskListType | null>(null);
  const [selectedPrompt, setSelectedPrompt] = useState<AskListType | null>(
    askMain === undefined ? null : askMain
  );
  const [conversationId, setConversationId] = useState<string>(
    currentConversationId
  );

  function findParents(items: CategoryRow[], idArray: string[]): CategoryRow[] {
    const parentChain: CategoryRow[] = [];
    for (const elem of idArray) {
      let currentItem = items.find(item => item.id === elem);
      while (currentItem) {
        if (parentChain.filter(i => i.id === currentItem?.id).length === 0) {
          parentChain.push(currentItem);
        }
        if (currentItem.parentId === null) break;
        currentItem = items.find(item => item.id === currentItem?.parentId);
      }
    }
    return parentChain;
  }

  function nestCategories(categories: CategoryListType[]): CategoryListType[] {
    const categoryMap: { [id: string]: CategoryListType } = {};
    const nestedCategories: CategoryListType[] = [];

    // Create a map of categories by their id for efficient lookup
    categories.forEach(category => {
      categoryMap[category.id] = { ...category };
    });

    // Traverse the categories and nest them based on parentId
    categories.forEach(category => {
      if (category.parentId !== null && category.parentId in categoryMap) {
        const parentCategory = categoryMap[category.parentId];
        if (!parentCategory.child) {
          parentCategory.child = [];
        }
        parentCategory.child.push(category);
      } else {
        nestedCategories.push(category);
      }
    });

    return nestedCategories;
  }

  function generateNestedArray(
    data: CategoryRow[],
    prompts: Row[]
  ): AskListType[] {
    const generatedAskListType = [] as AskListType[];
    const middleType = [] as CategoryListType[];

    for (const item of data) {
      middleType.push({
        id: item.id,
        name: item.name,
        parentId: item.parentId === undefined ? null : item.parentId,
        child: prompts
          .filter(i => i.categoryId === item.id)
          .map(({ id, name, prompt }) => ({
            id: id,
            name: name,
            prompt: prompt,
            parentId: item.parentId ?? null,
          })),
      });
    }
    console.log('');

    const emptyItems = prompts.filter(
      i => !data.map(a => a.id).includes(i.categoryId)
    );
    console.log('empty', emptyItems);

    const newItem = nestCategories(middleType);
    for (const item of newItem) {
      generatedAskListType.push({
        id: item.id,
        name: item.name,
        child: item.child,
        parentId: item.parentId,
      });
    }
    return generatedAskListType;
  }

  useEffect(() => {
    if (messageRef.current) {
      messageRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });
    }
  }, [currentMessageHolder]);

  useEffect(() => {
    if (setAskMainType) {
      setAskMainType(selectedPrompt);
    }
  }, [selectedPrompt]);

  useEffect(() => {
    if (setMainConversationId) {
      setMainConversationId(conversationId);
    }
    if (setMainMessageHolder) {
      setMainMessageHolder(currentMessageHolder);
    }
  }, [currentMessageHolder, conversationId]);

  useEffectAsync(async () => {
    const categories =
      (await coreServices.getPromptCategoryAll()) as AiCategoriesResponse;
    const prompts = (await coreServices.getPromptAll()) as AiQueryResponse;
    let selectableCategories = [] as CategoryRow[];
    const subchildCategories = prompts.rows
      .filter(i => i.isActive && !i.isDeleted && i.related === 'knowledge')
      .map(f => f.categoryId);
    console.log('subchildCategories', subchildCategories);

    selectableCategories = findParents(
      categories.rows.filter(i => !i.isDeleted),
      subchildCategories
    );

    const initialAskList = generateNestedArray(
      selectableCategories,
      prompts.rows.filter(
        i => i.isActive && !i.isDeleted && i.related === 'knowledge'
      )
    ) as AskListType[];
    console.log(
      'aaaa',
      generateNestedArray(
        categories.rows.filter(i => !i.isDeleted),
        prompts.rows.filter(i => i.isActive && !i.isDeleted)
      )
    );
    setAskList(initialAskList);
  }, []);

  const [askList, setAskList] = useState<AskListType[]>([]);

  const onConversation = (e: string) => {
    const messageHolderQuery = [...currentMessageHolder];
    messageHolderQuery.push({
      from: 'user',
      message: e,
      type: 'message',
    });
    messageHolderQuery.push({
      from: 'ai',
      message: '...',
      type: 'message',
    });
    setCurrentMessageHolder([...messageHolderQuery]);

    let headers = {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + localStorage.getItem('userToken'),
    };
    let body = {
      aiQueryType: 'knowledge',
      prompt: e,
      promptId: selectedPrompt?.id,
    };
    if (conversationId !== '') {
      (body as any).conversationId = conversationId;
    }
    axios
      .post(
        (process.env.REACT_APP_MERGEFLO_API_URL ?? '') + '/api/v1/aiquery',
        body,
        {
          headers: headers,
        }
      )
      .then(res => {
        const queryResponse = res.data as AiQueryResponse;
        console.log('res', res);
        let newMessageHolder = [...messageHolderQuery];
        newMessageHolder = newMessageHolder.filter(i => i.message !== '...');
        window.setTimeout(function () {}, 2000);
        newMessageHolder.push({
          from: 'ai',
          message: queryResponse.result,
          type: 'message',
        });
        setConversationId(queryResponse.conversationId);
        setCurrentMessageHolder([...newMessageHolder]);
        window.setTimeout(function () {}, 2000);
      })
      .catch(err => {
        let newMessageHolder = [...messageHolderQuery];
        newMessageHolder = newMessageHolder.filter(i => i.message !== '...');
        newMessageHolder.push({
          from: 'ai',
          type: 'message',
          message:
            'I encountered with some errors on query. Please contact with mergeflo.com for this situation',
        });
        setCurrentMessageHolder([...newMessageHolder]);
        window.setTimeout(function () {}, 2000);
      });
  };

  const copyAiMessage = (message: string) => {
    navigator.clipboard.writeText(message);
    toast('Copied', { position: 'top-right' });
  };

  return (
    <React.Fragment>
      <div
        className={[
          css.aiModalTabContent,
          currentMessageHolder.length === 0 ? css.WorkplanTabContent : '',
          ' customScroll',
        ].join(' ')}
      >
        {currentMessageHolder.length === 0 ? (
          <>
            <div className={css.aiTitleMid}>Select from list to start</div>
            <div className={css.workplanItemButtonContent}>
              {askList
                ?.filter(f => f.parentId === null)
                .map(ask => (
                  <button
                    className={css.workplanItemButton}
                    key={ask.id}
                    onClick={() => {
                      setSelectedAskItem(ask);
                      setReSelectedAskItem(null);
                      setSelectedPrompt(null);
                    }}
                  >
                    <Icons.UndoGradient />
                    <span>{ask.name}</span>
                  </button>
                ))}
            </div>
            {selectedAskItem?.child && selectedAskItem?.child?.length > 0 && (
              <div
                className={[css.workplanItemButtonContent, css.border].join(
                  ' '
                )}
              >
                {selectedAskItem.child?.map(ask => (
                  <button
                    className={css.workplanItemButton}
                    key={ask.id}
                    onClick={() => {
                      if (
                        selectedAskItem.child &&
                        selectedAskItem.child.length > 0
                      ) {
                        setReSelectedAskItem(ask);
                        setSelectedPrompt(null);
                      } else {
                        console.log('here');
                      }
                    }}
                  >
                    <Icons.UndoGradient />
                    <span>{ask.name}</span>
                  </button>
                ))}
              </div>
            )}
            {reselectedAskItem?.child && reselectedAskItem?.child?.length > 0 && (
              <div
                className={[css.workplanItemButtonContent, css.border].join(
                  ' '
                )}
              >
                {reselectedAskItem.child?.map(ask => (
                  <button
                    className={css.workplanItemButton}
                    title={ask.prompt ?? ''}
                    key={ask.id}
                    onClick={() => {
                      setSelectedPrompt(ask);
                      const messageHolder = [] as MessageHolder[];
                      messageHolder.push({
                        from: 'user',
                        message: ask.prompt ?? ask.name,
                        type: 'message',
                      });
                      messageHolder.push({
                        from: 'ai',
                        message: '...',
                        type: 'message',
                      });
                      setCurrentMessageHolder([...messageHolder]);
                      let headers = {
                        'Content-Type': 'application/json',
                        Authorization:
                          'Bearer ' + localStorage.getItem('userToken'),
                      };
                      let body = {
                        aiQueryType: 'knowledge',
                        promptId: ask.id,
                        prompt: ask.prompt ?? ask.name,
                      };
                      if (conversationId !== '') {
                        (body as any).conversationId = conversationId;
                      }
                      axios
                        .post(
                          (process.env.REACT_APP_MERGEFLO_API_URL ?? '') +
                            '/api/v1/aiquery',
                          body,
                          {
                            headers: headers,
                          }
                        )
                        .then(res => {
                          const queryResponse = res.data as AiQueryResponse;
                          console.log('res', res);
                          let newMessageHolder = [...messageHolder];
                          newMessageHolder = newMessageHolder.filter(
                            i => i.message !== '...'
                          );
                          window.setTimeout(function () {}, 2000);
                          newMessageHolder.push({
                            from: 'ai',
                            message: queryResponse.result,
                            type: 'message',
                          });
                          setConversationId(queryResponse.conversationId);
                          setCurrentMessageHolder([...newMessageHolder]);
                          window.setTimeout(function () {}, 2000);
                        })
                        .catch(err => {
                          let newMessageHolder = [...messageHolder];
                          newMessageHolder = newMessageHolder.filter(
                            i => i.message !== '...'
                          );
                          newMessageHolder.push({
                            from: 'ai',
                            type: 'message',
                            message:
                              'I encountered with some errors on query. Please contact with mergeflo.com for this situation',
                          });
                          setCurrentMessageHolder([...newMessageHolder]);
                          window.setTimeout(function () {}, 2000);
                        });
                    }}
                  >
                    <Icons.UndoGradient />
                    <span>{ask.name}</span>
                  </button>
                ))}
              </div>
            )}
          </>
        ) : (
          <>
            <div className={css.messageContent}>
              {currentMessageHolder.map((message, index) => (
                <div
                  key={index}
                  className={[css.messageContent, ' customScroll'].join(' ')}
                  ref={messageRef}
                >
                  {message.from === 'user' ? (
                    <>
                      <div className={css.userMessageContent}>
                        <div className={css.messageUser}>
                          <div
                            style={{
                              display: 'flex',
                              flex: 'wrap',
                              flexDirection: 'row',
                              justifyContent: 'center',
                              alignItems: 'center',
                            }}
                          >
                            {message.icon && <div> {message.icon}</div>}
                            {message.icon && (
                              <div>
                                Document selected: <br /> {message.message}
                              </div>
                            )}
                            {message.icon === undefined && message.message}
                          </div>
                        </div>
                        <Avatar
                          className={css.userAvatar}
                          style={{
                            backgroundColor: mergefloColors.getUserColors(
                              userInfo?.name ?? 'N'
                            ),
                            fontSize: 15,
                            fontWeight: 'bold',
                          }}
                        >
                          {generateAvatar()}
                        </Avatar>
                      </div>
                    </>
                  ) : (
                    <div className={css.aiMessageContent}>
                      <Avatar className={css.aiAvatar}>
                        <Icons.Undo />
                      </Avatar>
                      <div className={css.messageAi}>
                        <div className="copy-ai-btn-content">
                          <button
                            onClick={() => copyAiMessage(message.message)}
                          >
                            Copy
                          </button>
                        </div>
                        {message.message}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
      <AiMessageInput
        placeholder={
          selectedPrompt === null
            ? 'Choose an option to start the conversation'
            : 'Type your query here to get a response from Mergeflo AI'
        }
        disabled={selectedPrompt === null && askList.length === 0}
        onConversation={onConversation}
      />
    </React.Fragment>
  );
};

export default KnowledgebaseTab;
